var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 7.35473C2.66932 7.35097 2.67207 7.34725 2.67467 7.34349C2.67418 7.34725 2.67363 7.35097 2.67316 7.35473H2.66675ZM13.3334 7.71389C13.3334 6.69412 13.1538 5.75771 12.6664 4.87904C11.7171 3.17943 10.0361 2.25587 8.06707 2.25587C4.82633 2.24946 3.01189 4.69256 2.67467 7.34352C3.65731 5.92356 5.38603 4.5325 7.77846 4.44936C7.77846 4.44936 10.3183 4.44936 10.081 6.88012H6.00828C6.15578 6.01427 6.43798 5.51403 6.80355 5.05223C5.06548 5.86033 3.98156 7.27777 4.00722 9.41352C4.02645 11.0682 5.16807 12.7679 6.80358 13.3964C8.73409 14.134 11.2682 13.5632 12.3649 12.9026V10.4846C10.4922 11.793 6.09168 11.8956 6.05962 8.91966H13.3334V7.71389H13.3334Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdge);
export default __webpack_public_path__ + "static/media/edge.38f5fb072fe88f89e68f523798b23082.svg";
export { ForwardRef as ReactComponent };